"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const dist_1 = require("../../../fs/dist");
const runEvent_1 = require("../../../app/dist/runEvent");
const completeStep_1 = require("../../../app/dist/completeStep");
const planUlid_1 = require("./planUlid");
exports.toolDef = {
    name: 'loom_complete_step',
    description: 'Mark a plan step as done. Call only on plans with status "implementing". Idempotent if the step is already done. Use this tool to mark steps complete — do not edit plan files directly.',
    inputSchema: {
        type: 'object',
        properties: {
            plan_ulid: { type: 'string', description: 'Plan\'s stable pl_ ULID (e.g. "pl_01J…"). ULID only — a filename stem or title is rejected.' },
            stepNumber: { type: 'number', description: 'Step number (1-based)' },
        },
        required: ['plan_ulid', 'stepNumber'],
    },
};
async function handle(root, args) {
    const planUlid = (0, planUlid_1.requirePlanUlid)(args);
    const stepNumber = args['stepNumber'];
    const loadWeaveStrict = async (r, w) => {
        const result = await (0, dist_1.loadWeave)(r, w);
        if (!result)
            throw new Error(`Weave not found: ${w}`);
        return result;
    };
    const deps = {
        loadWeave: loadWeaveStrict,
        runEvent: (weaveSlug, event) => (0, runEvent_1.runEvent)(weaveSlug, event, { loadWeave: loadWeaveStrict, saveDocs: dist_1.saveDocs, loomRoot: root }),
        loomRoot: root,
    };
    const { plan, autoCompleted } = await (0, completeStep_1.completeStep)({ planUlid, step: stepNumber }, deps);
    // Stopgap: do not echo the whole PlanDoc back on every call (redundant across a
    // multi-step session — the agent already holds the plan). Return a reference plus
    // the changed step and a compact status line for the rest.
    const completedStep = (plan.steps ?? []).find(s => s.order === stepNumber);
    const trimmed = {
        planId: plan.id,
        planStatus: plan.status,
        autoCompleted,
        completedStep: completedStep
            ? { order: completedStep.order, status: completedStep.status, description: completedStep.description }
            : { order: stepNumber, status: 'done' },
        steps: (plan.steps ?? []).map(s => ({ order: s.order, status: s.status })),
    };
    return { content: [{ type: 'text', text: JSON.stringify(trimmed) }] };
}
